import { render } from "./HTextarea.vue?vue&type=template&id=0367fd5e&scoped=true"
import script from "./HTextarea.vue?vue&type=script&lang=js"
export * from "./HTextarea.vue?vue&type=script&lang=js"

import "./HTextarea.vue?vue&type=style&index=0&id=0367fd5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0367fd5e"]])

export default __exports__